import { useLocation } from "react-router-dom";
import Footer from "@/components/Footer";

// Path prefixes that should NOT render the global footer (logged-in surfaces / onboarding modals)
const HIDDEN_PREFIXES = [
  "/dashboard",
  "/onboarding",
  "/login",
  "/register",
  "/registrations/success",
];

export default function GlobalFooter() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p))) {
    // Dashboard / onboarding still need a minimal copyright + IP line for
    // trademark + audit purposes. Single quiet line, no big footer.
    return (
      <div
        className="border-t border-white/5 mt-16 py-6 px-6 md:px-12 bg-[#050505]"
        data-testid="slim-copyright-footer"
      >
        <div className="max-w-7xl mx-auto text-[10px] text-white/30 flex flex-col md:flex-row gap-1.5 md:gap-4 justify-between leading-relaxed">
          <span>© {new Date().getFullYear()} OmniSportsGroup, LLC. All Rights Reserved.</span>
          <span className="text-white/25">
            All intellectual property created for OmniAgency is owned exclusively by OmniSportsGroup, LLC.
          </span>
        </div>
      </div>
    );
  }
  return <Footer />;
}
